/**
 * ui/services/sync-events.ts
 *
 * The window event account sync fires after bringing in changes from the
 * player's other devices, for pages that show that data.
 */
import type { SyncKind } from '../../ports/account.js';

export const SYNC_APPLIED_EVENT = 'nono-sync-applied';

/** The event's detail: the ids that changed, by kind. */
export type SyncAppliedDetail = Partial<Record<SyncKind, string[]>>;

/** Calls `listener` with each sync's changes. Returns an unsubscribe function. */
export function onSyncApplied(listener: (detail: SyncAppliedDetail) => void): () => void {
  const handler = (event: Event) => listener((event as CustomEvent<SyncAppliedDetail>).detail ?? {});
  globalThis.addEventListener?.(SYNC_APPLIED_EVENT, handler);
  return () => globalThis.removeEventListener?.(SYNC_APPLIED_EVENT, handler);
}
